import React from "react";

export const DashboardHeader: React.FC = () => {
    // The dashboard grid alert is discontinued
    return <></>;
}
